export default __webpack_public_path__ + "static/skicka_faktura_spara-f15457ba6a308080304a2dd6c5683bc0.png";